import { SearchOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import { useDebounce } from '@uidotdev/usehooks';
import {
  Checkbox,
  ConfigProvider,
  Drawer,
  Form,
  Input,
  Space,
  Typography,
} from 'antd';
import { SaleTeamApi } from 'apis/SaleTeamApi';
import { XGrayIcon } from 'assets/svg';
import ButtonAction from 'components/Button/ButtonAction';
import TableMoveRow from 'components/Table/TableMoveRow';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import { ChangeEvent, ReactNode, useEffect, useMemo, useState } from 'react';
import { formatCurrency } from 'utils/constants/functions';

interface Iprops {
  setOpen: any;
  open: boolean;
  routeId: any;
  teamsaleId: any;
  children?: ReactNode;
}

const DrawerSaleLineTeam = ({ setOpen, open, teamsaleId, routeId }: Iprops) => {
  const [data, setData] = useState<any>([]);
  const [form] = Form.useForm();

  const [searchCustomer, setSearchCustomer] = useState('');
  const searchCustomerDebounce = useDebounce(searchCustomer, 500);
  const scrollTable = useMemo(
    () => ({
      x: 875,
    }),
    [],
  );

  const renderValueTable = (value: any) => value || '-';

  const { isPending: getKHByTeamAndLineLoading, mutate: getKHByTeamAndLines } =
    useMutation({
      mutationFn: (params: any) =>
        SaleTeamApi.GetCustomerByTeamSaleRoute(params),
      onSuccess: (res) => {
        const data: any[] = res.data.getCustTeamRouteView.items;
        setData(data);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  useEffect(() => {
    if (!open) return;

    const searchValue = searchCustomerDebounce.trim();

    routeId &&
      getKHByTeamAndLines({
        routeId: { equals: routeId },
        teamSaleId: { equals: teamsaleId },
        OR: [
          {
            id: { contains: searchValue },
          },
          {
            storeName: { contains: searchValue },
          },
          {
            sapCustomerId: { contains: searchValue },
          },
        ],
      });
  }, [getKHByTeamAndLines, open, routeId, searchCustomerDebounce, teamsaleId]);

  const columns: ColumnsTypeCustom = useMemo(
    () => [
      {
        // title: "Thao tác",
        className: 'shadow-right',
        width: 80,
        fixed: 'left',
        align: 'center',
        render: () => (
          <Space size={'middle'} className="text-lg ">
            {/* <ButtonAction tooltip="Xem chi tiết">
              <EyeIcon />
            </ButtonAction> */}
          </Space>
        ),
      },
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 50,
        render: (_: any, __: any, index: number) => index + 1,
      },
      {
        title: 'Mã khách hàng',
        width: 150,
        dataIndex: 'sapCustomerId',
      },
      {
        title: 'Mã DMS',
        dataIndex: 'id',
        width: 150,
      },
      {
        title: 'Tên Cửa Hàng',
        dataIndex: ['storeName'],
        width: 200,
        render: renderValueTable,
      },
      {
        title: 'Hạng thẻ',
        dataIndex: ['rankName'],
        width: 100,
        render: renderValueTable,
      },
      {
        currency: 'vi-VN',
        title: 'Doanh thu trung bình',
        dataIndex: 'expectedRevenue',
        key: 'storeName',
        width: 180,
        align: 'right',
        render: (value) =>
          value ? formatCurrency({ value, round: true }) : '-',
      },
      {
        title: 'MST',
        dataIndex: ['taxId'],
        width: 150,
        render: renderValueTable,
      },
      {
        title: 'SDT',
        dataIndex: ['phone'],
        width: 150,
        render: renderValueTable,
      },
      {
        title: 'CCCD',
        dataIndex: ['cccd'],
        width: 150,
        render: renderValueTable,
      },
      {
        title: 'Địa chỉ chi tiết',
        dataIndex: ['address'],
        width: 150,
        render: renderValueTable,
      },
      {
        title: 'Tỉnh/Thành Phố',
        dataIndex: ['cityName'],
        width: 140,
        render: renderValueTable,
      },
      {
        title: 'Quận/Huyện',
        dataIndex: ['districtName'],
        width: 160,
        render: renderValueTable,
      },
      {
        title: 'Phường/Xã',
        dataIndex: ['wardName'],
        width: 120,
        render: renderValueTable,
      },
      // {
      //   title: 'stop_mk',
      //   dataIndex: 'stopMk',
      //   width: 85,
      // },
      // {
      //   title: 'stop_time',
      //   dataIndex: 'stopTime',
      //   width: 85,
      // },
      // {
      //   title: 'Stop user',
      //   dataIndex: 'stopUser',
      //   width: 85,
      // },
      {
        title: 'T2',
        dataIndex: 't2',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'T3',
        dataIndex: 't3',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'T4',
        dataIndex: 't4',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'T5',
        dataIndex: 't5',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'T6',
        dataIndex: 't6',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'T7',
        dataIndex: 't7',
        align: 'center',
        width: 35,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'CN',
        dataIndex: 'cn',
        align: 'center',
        width: 36,
        render: (value: any) => (
          <Form.Item className="mb-0">
            <Checkbox checked={value} />
          </Form.Item>
        ),
      },
      {
        title: 'Tần suất đi trong tháng',
        children: [
          {
            title: 'Tuần 1',
            dataIndex: 'week1',
            align: 'center',
            width: 60,
            render: (value: any) => (
              <Form.Item className="mb-0">
                <Checkbox checked={value} />
              </Form.Item>
            ),
          },
          {
            title: 'Tuần 2',
            dataIndex: 'week2',
            align: 'center',
            width: 60,
            render: (value: any) => (
              <Form.Item className="mb-0">
                <Checkbox checked={value} />
              </Form.Item>
            ),
          },
          {
            title: 'Tuần 3',
            dataIndex: 'week3',
            align: 'center',
            width: 60,
            render: (value: any) => (
              <Form.Item className="mb-0">
                <Checkbox checked={value} />
              </Form.Item>
            ),
          },
          {
            title: 'Tuần 4',
            dataIndex: 'week4',
            align: 'center',
            width: 60,
            render: (value: any) => (
              <Form.Item className="mb-0">
                <Checkbox checked={value} />
              </Form.Item>
            ),
          },
        ],
      },
    ],
    [],
  );

  const onClose = () => {
    setSearchCustomer('');
    setOpen(false);
  };

  // function handleOK(data: any) {
  //   data.forEach((customer: any) =>
  //     addCustomer({
  //       custId: customer.customerId,
  //       routeId,
  //       teamId: teamsaleId,
  //     }),
  //   );
  // }

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) =>
    setSearchCustomer(e.target.value);

  return (
    <Drawer
      width={'60%'}
      // size="default"
      title={
        <Typography.Text className="text-[#003056] font-bold text-2xl">
          Khách hàng trong tuyến
        </Typography.Text>
      }
      onClose={onClose}
      open={open}
      closable={false}
      destroyOnClose
      extra={<ButtonAction title={<XGrayIcon />} onClick={onClose} />}
    >
      <Form form={form}>
        <Space className="flex mb-3 justify-end mr-5">
          <ConfigProvider
            theme={{
              token: {
                borderRadius: 50,
              },
            }}
          >
            <Input
              value={searchCustomer}
              onChange={handleChangeSearch}
              placeholder="Tìm khách hàng theo tên, mã"
              className="p-2 w-64 bg-[#EFF3F8]"
              prefix={<SearchOutlined className="mx-1" />}
            />
          </ConfigProvider>
          {/* <Button
            type="button"
            customClass="bg-white"
            title={<PlusIcon />}
            handleOnclick={() => setOpenAddCustomer(true)}
          /> */}
        </Space>
        <TableMoveRow
          rowKey="id"
          setDataSource={setData}
          dataSource={data}
          columns={columns}
          loading={getKHByTeamAndLineLoading}
          scroll={scrollTable}
          pagination={false}
        />
        {/* <ModalAddCustomerToRoute
          open={openAddCustomer}
          setOpen={setOpenAddCustomer}
          searchId={{ teamId: teamsaleId, routeId }} // cần xem lại
          handleOK={handleOK}
          type="SaleLineTeamSale"
        /> */}
      </Form>
    </Drawer>
  );
};

export default DrawerSaleLineTeam;
